"use strict";

document.addEventListener("DOMContentLoaded", initMatchSymbolsGame);
document.addEventListener("shopify:section:load", initMatchSymbolsGame);

function initMatchSymbolsGame() {
  const root = document.querySelector(".match-symbols-game");
  if (!root || root.dataset.initialized === "true") return;
  root.dataset.initialized = "true";

  const cards = root.querySelectorAll(".card");
  const imgsContainer = root.querySelectorAll(".element");
  const imgs = root.querySelectorAll(".element img");
  const restartBtn = root.querySelector(".restart-btn");
  const numberOfMoves = root.querySelector(".moves");
  const bestScore = root.querySelector(".best--score");
  const bestTime = root.querySelector(".best--time");
  const time = root.querySelector(".time");
  const totalTime = root.querySelector(".tot-time");
  const totalMoves = root.querySelector(".tot-moves");
  const done = root.querySelector(".done");
  const again = root.querySelector(".again");
  const destinySymbolBtn = root.querySelector(".destiny-symbol-btn");

  let activeCard = null;
  let numberOfActiveCards = 0;
  let solved = 0;
  let moves = 0;
  let best = -1;
  let bestTimeValue = -1;
  let intervalId = null;
  let elapsedTime = 0;
  let boardLocked = false;

  const sourceImages = Array.isArray(window.matchSymbolsImages)
    ? window.matchSymbolsImages
    : [];

  const destinyLinks = Array.isArray(window.destinySymbolLinks)
    ? window.destinySymbolLinks
    : [];

  if (sourceImages.length !== 8) {
    console.error("matchSymbolsImages must contain exactly 8 images.");
    return;
  }

  function startTimer() {
    if (intervalId) clearInterval(intervalId);

    elapsedTime = 0;
    time.textContent = elapsedTime;

    intervalId = setInterval(() => {
      elapsedTime++;
      time.textContent = elapsedTime;
    }, 1000);
  }

  function updateMoves(value) {
    numberOfMoves.textContent = value;
  }

  function generateRandomImages() {
    const arr = [...sourceImages, ...sourceImages].sort(() => Math.random() - 0.5);

    imgs.forEach((img, i) => {
      img.src = arr[i];
    });
  }

  function resetMatchedState() {
    cards.forEach((card) => {
      card.dataset.matched = "false";
    });
  }

  function hideCard(card) {
    card.classList.remove("active");
    card.style.transform = "rotateY(180deg)";
    card.children[0].style.transform = "rotateY(-180deg)";
    card.children[0].style.opacity = 0;
  }

  function showCard(card) {
    card.classList.add("active");
    card.style.transform = "rotateY(0deg)";
    card.children[0].style.transform = "rotateY(0deg)";
    card.children[0].style.opacity = 1;
  }

  function markMatched(card) {
    card.dataset.matched = "true";
    card.classList.remove("active");
    card.classList.add("matched");
    card.children[0].style.opacity = "0.5";
  }

  function goToRandomDestinySymbol() {
    if (!destinyLinks.length) return;

    const randomIndex = Math.floor(Math.random() * destinyLinks.length);
    const randomLink = destinyLinks[randomIndex];

    window.location.href = randomLink;
  }

  function init() {
    generateRandomImages();
    resetMatchedState();

    imgsContainer.forEach((img) => {
      img.style.opacity = 0;
      img.style.transform = "rotateY(-180deg)";
    });

    cards.forEach((card) => {
      card.style.transform = "rotateY(180deg)";
      card.classList.remove("active");
      card.classList.remove("matched");
    });

    startTimer();

    numberOfMoves.textContent = "0";
    solved = 0;
    moves = 0;
    numberOfActiveCards = 0;
    activeCard = null;
    boardLocked = false;

    bestScore.textContent = best === -1 ? "" : best;
    bestTime.textContent = bestTimeValue === -1 ? "" : bestTimeValue;

    done.classList.add("hidden");
  }

  restartBtn.addEventListener("click", init);
  again.addEventListener("click", init);

  if (destinySymbolBtn) {
    destinySymbolBtn.addEventListener("click", goToRandomDestinySymbol);
  }

  imgs.forEach((img) => {
    img.addEventListener("dragstart", (e) => {
      e.preventDefault();
    });
  });

  cards.forEach((card) => {
    card.addEventListener("click", () => {
      if (boardLocked) return;
      if (card.dataset.matched === "true") return;
      if (card === activeCard) return;
      if (Number(card.children[0].style.opacity) !== 0) return;

      showCard(card);

      moves++;
      numberOfActiveCards++;
      updateMoves(moves);

      if (numberOfActiveCards === 1) {
        activeCard = card;
        return;
      }

      numberOfActiveCards = 0;

      const firstSrc = activeCard.children[0].children[0].src;
      const secondSrc = card.children[0].children[0].src;

      if (firstSrc === secondSrc) {
        markMatched(activeCard);
        markMatched(card);
        solved++;
        activeCard = null;
      } else {
        boardLocked = true;

        setTimeout(() => {
          hideCard(card);
          hideCard(activeCard);
          activeCard = null;
          boardLocked = false;
        }, 600);
      }

      if (solved === 8) {
        clearInterval(intervalId);

        if (best === -1 || moves < best) best = moves;
        if (bestTimeValue === -1 || elapsedTime < bestTimeValue) {
          bestTimeValue = elapsedTime;
        }

        totalMoves.textContent = moves;
        totalTime.textContent = elapsedTime;

        setTimeout(() => {
          done.classList.remove("hidden");
        }, 500);
      }
    });
  });

  init();
}